module.exports = __webpack_public_path__ + "static/img/46.ee96d70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/46.png
// module id = BS93
// module chunks = 0